define("shared/utils/time", ["exports", "@ember/debug"], function (_exports, _debug) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.seconds = _exports.minutes = _exports.hoursBetweenUnixTimestamps = _exports.hours = _exports.default = _exports.days = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug"eaimeta@70e063a35619d71f
  /**
   * @module Utils
   */
  /**
   * @class TimeUtil
   * @extends Utils
   */

  /**
   * Creates and returns a new Date object set to N days in the future. If a date is provided, it will be mutated.
   * @method days
   * @param {Number} num The number of days in the future the Date object will be set to
   *
   * @returns {Date} The formatted date object
   */
  const days = function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
    (false && !(typeof num === 'number') && (0, _debug.assert)('input must be a number', typeof num === 'number'));
    date.setDate(date.getDate() + num);
    return date;
  };

  /**
   * Creates and returns a new Date object set to N hours in the future. If a date is provided, it will be mutated.
   * @method hours
   * @param {Number} num The number of hours in the future the Date object will be set to
   *
   * @returns {Date} The formatted date object
   */
  _exports.days = days;
  const hours = function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    (false && !(typeof num === 'number') && (0, _debug.assert)('input must be a number', typeof num === 'number'));
    const date = new Date();
    date.setHours(date.getHours() + num);
    return date;
  };

  /**
   * Creates and returns a new Date object set to N minutes in the future. If a date is provided, it will be mutated.
   * @method minutes
   * @param {Number} num The number of minutes in the future the Date object will be set to
   *
   * @returns {Date} The formatted date object
   */
  _exports.hours = hours;
  const minutes = function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    (false && !(typeof num === 'number') && (0, _debug.assert)('input must be a number', typeof num === 'number'));
    const date = new Date();
    date.setMinutes(date.getMinutes() + num);
    return date;
  };

  /**
   * Creates and returns a new Date object set to N seconds in the future. If a date is provided, it will be mutated.
   * @method seconds
   * @param {Number} num The number of minutes in the future the Date object will be set to
   *
   * @returns {Date} The formatted date object
   */
  _exports.minutes = minutes;
  const seconds = function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    (false && !(typeof num === 'number') && (0, _debug.assert)('input must be a number', typeof num === 'number'));
    const date = new Date();
    date.setSeconds(date.getSeconds() + num);
    return date;
  };
  _exports.seconds = seconds;
  const hoursBetweenUnixTimestamps = (a, b) => {
    return moment(b * 1000).diff(moment(a * 1000), 'hours');
  };
  _exports.hoursBetweenUnixTimestamps = hoursBetweenUnixTimestamps;
  var _default = _exports.default = {
    days,
    hours,
    minutes,
    seconds,
    hoursBetweenUnixTimestamps
  };
});